module.exports = __webpack_public_path__ + "img/analytics.f8c9021f.svg";